import { useI18n } from '@i18n/I18nProvider'
import type { MessageKey } from '@i18n/messages'
import { Icon, type IconName } from '@ui/Icon'
import { Link, useLocation } from 'wouter'

export const NAV_ITEMS: { href: string; label: MessageKey; icon: IconName }[] = [
	{ href: '/', label: 'nav.map', icon: 'map' },
	{ href: '/etapas', label: 'nav.stages', icon: 'route' },
	{ href: '/formacion', label: 'nav.learn', icon: 'book' },
	{ href: '/mas', label: 'nav.more', icon: 'more' },
]

// Una sección está activa en su ruta y en sus subrutas (/etapas/123 → Etapas).
export const isActive = (href: string, location: string): boolean =>
	href === '/' ? location === '/' : location === href || location.startsWith(`${href}/`)

// Barra inferior fija: el pulgar llega a todo con una mano. No sale en el panel de la
// asociación, que tiene sus propias pestañas.
export const BottomNav = () => {
	const { t } = useI18n()
	const [location] = useLocation()
	if (isActive('/panel', location)) return null
	return (
		<nav
			aria-label={t('app.name')}
			className="fixed inset-x-0 bottom-0 z-20 border-t border-earth-300 bg-white pb-[env(safe-area-inset-bottom)]"
		>
			<ul className="mx-auto grid max-w-xl grid-cols-4">
				{NAV_ITEMS.map((item) => {
					const active = isActive(item.href, location)
					return (
						<li key={item.href}>
							<Link
								href={item.href}
								aria-current={active ? 'page' : undefined}
								className={`flex min-h-16 flex-col items-center justify-center gap-1 text-xs font-semibold ${active ? 'text-forest-700' : 'text-earth-800'}`}
							>
								<Icon name={item.icon} />
								{t(item.label)}
							</Link>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}
